export default "__VITE_ASSET__78154465__"